import React from 'react';
import PropTypes from 'prop-types';

const ButtonDropdownMenuItem = ({
  text, danger, onClick, rightIcon, leftIcon
}) => {
  const baseClasses = 'flex flex-row justify-between items-center px-[12px] py-[9px] rounded-[6px] capitalize';
  const activeClasses = danger
    ? 'text-danger hover:bg-danger-light hover:text-danger'
    : 'hover:bg-primary-light hover:text-primary';
  const disabledClasses = onClick ? '' : 'opacity-70 hover:text-text-second';

  return (
    <div
      className={`${baseClasses} ${activeClasses} ${disabledClasses}`}
      onClick={onClick}
      role="presentation"
    >
      <div className="flex items-center gap-[8px]">
        {leftIcon && <div className="flex items-center justify-center">{leftIcon}</div>}
        <div>{text}</div>
      </div>
      {rightIcon}
    </div>
  );
};

ButtonDropdownMenuItem.propTypes = {
  text: PropTypes.string,
  danger: PropTypes.bool,
  onClick: PropTypes.func,
  rightIcon: PropTypes.node,
  leftIcon: PropTypes.node,
};

ButtonDropdownMenuItem.defaultProps = {
  text: 'acton',
  danger: false,
  onClick: undefined,
  rightIcon: undefined,
  leftIcon: undefined
};

export default ButtonDropdownMenuItem;
